import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProjectCarousel() {
  const projectImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/8rvcoRVBWDFPnf4EmSuiM5/carrusel_1.webp',
    alt: 'Cartel Neon "Sueña Grande"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/1t75JiEdMd7LJZw8z5UXqz/carrusel_2.webp',
    alt: 'Cartel Neon "Tattoo Arte"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jtp5VdqJgHUfz3NNhCKCc3/carrusel_3.webp',
    alt: 'Cartel Neon "Abierto" con Copa'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/gAi9mCayMCw2XhMLW25msY/carrusel_4.webp',
    alt: 'Cartel Neon "Buenas Vibras" con Rayo'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/99mSWWnHCvKohY9EHBhguj/carrusel_5.webp',
    alt: 'Cartel Neon "Fiesta" Rosa'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9Kx6bFPtkMmyBmA7adjYMV/carrusel_6.webp',
    alt: 'Cartel Neon "Parrilla & Relax"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6mrkEiCvjGPdJGK2A4x22v/carrusel_7.webp',
    alt: 'Cartel Neon Charizard "Poder"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/soDA7sqFWJauucKJamM88C/Carrusel_8.webp',
    alt: 'Colección Neon Pokemon y Ofertas'
  }];
  const duplicatedImages = [...projectImages, ...projectImages];
  return <section className="py-20 px-4 relative z-10 bg-transparent overflow-hidden border-y border-white/5 pt-[0px] pb-[0px]" data-id="element-331">
      <style data-id="element-332">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            animation: scroll 40s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto px-4 text-center mb-12" data-id="element-333">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight" data-id="element-334">
          PROYECTOS QUE <span className="text-[#00f0ff]" data-id="element-335">VAS A LOGRAR</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-336">
          Desde carteles comerciales hasta piezas de decoración únicas. El
          límite es tu imaginación.
        </p>
      </div>

      <div className="relative w-full overflow-hidden py-10 pt-[45px] pb-[45px]" data-id="element-337">
        <div className="flex w-max animate-scroll gap-8 px-4" data-id="element-338">
          {duplicatedImages.map((image, index) => <div key={index} className="w-80 md:w-[450px] h-64 md:h-80 shrink-0 transition-all duration-500 hover:scale-105 hover:z-20 cursor-pointer group" data-id="element-339">
              <div className="relative w-full h-full overflow-hidden rounded-[2rem] transition-all" data-id="element-340">
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover" loading="lazy" data-id="element-341" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}